/* ============================================================================
   tne-revendedora-cta.js — Última secção da homepage
   DistribuidorTopBioEuropa | Site institucional B2B

   Comportamentos:
     1. Stagger entry dos números 01/02/03 — quando o grupo .tne-rev-cta__passos
        entra em viewport, alterna a classe .is-visible nos cards com delays
        progressivos (CSS faz o restante via custom property --tne-passo-delay).
     2. Sutil "shine" no botão CTA quando entra pela primeira vez em viewport
        (apenas se prefers-reduced-motion não ativo). O pulse contínuo é puro
        CSS — aqui só adicionamos um boost inicial de atenção.

   Nota: O fade-in base dos elementos .tne-fade-in é gerido pelo observer
   global em tne-sobre.js. Aqui apenas reforçamos comportamentos extra.
   ============================================================================ */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var section = document.querySelector('[data-tne-rev-cta]');
    if (!section) return;

    if (typeof IntersectionObserver === 'undefined') return;

    var passos = section.querySelector('[data-tne-rev-passos]');
    var btn = section.querySelector('.tne-btn-primary.tne-btn-large');

    if (passos) initPassosStagger(passos);
    if (btn && !prefersReduced) initBtnAttention(btn);
  }

  // Garante que a entry visual dos cards é "vista" como bloco, mesmo
  // quando o utilizador faz scroll rápido. Adiciona a classe .is-stagger-active
  // no contentor para hooks futuros (ex.: linhas conectoras animadas).
  function initPassosStagger(group) {
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        group.classList.add('is-stagger-active');
        obs.unobserve(group);
      });
    }, { threshold: 0.25 });

    observer.observe(group);
  }

  // Pequeno boost no botão quando aparece pela 1.ª vez (pulse extra de 1.5s).
  function initBtnAttention(btn) {
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        btn.classList.add('is-attention');
        window.setTimeout(function () {
          btn.classList.remove('is-attention');
        }, 1500);
        obs.unobserve(btn);
      });
    }, { threshold: 0.5 });

    observer.observe(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
